/*
redirectUsingPostService.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('redirectUsingPostService',['angular'], function () {

    var moduleDependencies = [];
    var redirectUsingPostServiceModule = angular.module('Services.redirectUsingPostService', moduleDependencies);

    redirectUsingPostServiceModule.factory('redirectUsingPostService', ['$window', 'authenticationStoreService', function ($window, authenticationStoreService) {
        var mapToPageUrl = function (pageCode) {
            return pageCode === 'sfa' ? '/secondFactorAuth' :
                pageCode === 'do' ? '/displayOrg' :
                    pageCode === 'ib' ? '/' :
                        pageCode === 'lo' ? '/logout' :
                            pageCode === 'alo' ? '/authenticationLogout' : '';
        };

        var redirectWithToken = function (redirectTo, token) {
            var pageUrl = mapToPageUrl(redirectTo);
            if (pageUrl && token) {
                if (sessionStorage.getItem("redirectUrl") && redirectTo === "ib") {
                    pageUrl = sessionStorage.getItem("redirectUrl");
                }
                var form = angular.element('<form target="_self" method="post"><input type="hidden" name="cIdToken" /></form>');
                form.attr('action', pageUrl);
                form.find('input').val(token);
                angular.element('body').append(form);
                form.submit();
                form.remove();
            } else {
                $window.location = '/login?message=440';
            }
        };

        var redirect = function (redirectTo) {
            redirectWithToken(redirectTo, authenticationStoreService.getCIdToken());
        };

        var download = function (downloadFrom) {
            if (downloadFrom && authenticationStoreService.getCIdToken()) {
                var form = angular.element('<form action="" target="_self" method="post"><input type="hidden" name="cIdToken" /></form>');
                form.attr('action', downloadFrom);
                form.find('input').val(authenticationStoreService.getCIdToken());
                angular.element('body').append(form);
                form.submit();
                form.remove();
            } else {
                $window.location = '/login?message=440';
            }
        };

        return {
            redirect: redirect,
            redirectWithToken: redirectWithToken,
            download: download
        };
    }]);
});

